import {ref  } from 'vue'

import telenormaritimeContent from '../assets/files/telenormaritime.json'
import ambassadorContent from '../assets/files/ambassador.json'
import carnivalContent from '../assets/files/carnival.json'

let jsonContent = ref()  

// export  function getContent(firm){
//     const customers = {
//         default: ambassadorContent,
//         ambassador: ambassadorContent,
//         carnival: carnivalContent
//       };
    
//       const ContentDefault = 'default'
//       const Content = computed(() => customers[firm || ContentDefault] )
//       jsonContent.value = Content;
//       console.log("asdf from module: " + carnivalContent.heading2)
// }


export  function getContent(firm){
    let Content = telenormaritimeContent;
   if(firm == 'carnival')
   {
     Content = carnivalContent;
   }
   else if (firm == 'ambassador')
   {
     Content = ambassadorContent;
   }

      jsonContent.value = Content;
      //console.log("asdf from module: " + carnivalContent.heading2)
}


  export  {jsonContent}  